<template>
	<div class="row">
		<div class="col-sm-offset-6 col-sm-6">
		    <input type="text" class="admin-input pull-right" placeholder="Buscar producto">
		</div>
	</div>
	<div class="table-responsive">
		<table class="table table-hover admin-table">
			<tbody>
				<tr class="clickable-row" v-for="product in render_products">
					<td>
						<div class="custom-checkbox-gray" style="margin-top: 30px;">
					        <input type="checkbox" :id="product.name">
					        <label :for="product.name" @click="toggleProduct($event, product)"></label>
				      	</div>
					</td>
					<td><img :src="product.images[0].route" alt=""></td>
					<td>{{ product.name }}</td>
					<td>{{ product.category_id }}</td>
					<td>{{ product.category_id }}</td>
				</tr>
			</tbody>
		</table>
		<div class="error" v-if="has_error">{{ msg_error }}</div>
	</div>
</template>

<style scoped>
	.table-responsive{
		background-color: white;
	}
	.btn-blue{
		padding: 5px 12px;
	}
</style>

<script>
var form = {
	product_ids: []
};

export default {
	data () {
		return {
			form: form
		}
	},

	vuex: {
		getters: {
			products: state => state.products
		}
	},

	methods: {
		toggleProduct (e, product) {
			this.msg_error = '';
			this.has_error = false;
			// Delete the product if this already exists in the array.
			for (var i = 0, p = this.form.product_ids; i < p.length; i++) {
				if (product.id == p[i]) {
					p.splice(i, 1);
					return;
				}
			}
			
			this.form.product_ids.push(product.id);
		}
	},

	computed: {
		render_products () {
			return this.products;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-projects-products.vue?fa8b7282